import classNames from 'classnames';
import React from 'react';
import { LabelWithoutEventBubbling } from "../../helper/components/LabelWithoutEventBubbling.js";
import { LegacyIconRenderer } from "../../helper/components/LegacyIconRenderer.js";
import { useStableId } from "../../helper/hooks/useStableId.js";
import { getVariantClasses } from "../variantProvider/functions/getVariantClasses.js";
import styles from "./Radio.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Radio = ({
  label,
  error,
  disabled,
  className,
  children,
  inputRef,
  onClick,
  icon,
  iconSize = 48,
  isTile,
  condensed,
  outline,
  variant = 'PRIMARY',
  id,
  ...rest
}) => {
  const inputId = useStableId(id);
  const classes = classNames(styles.radio, disabled && styles.disabled, error && styles.error, isTile && styles.tile, isTile && condensed && styles.condensed, getVariantClasses(isTile ? 'SECONDARY' : variant), className);
  const labelClasses = classNames(styles.label, icon && styles.hasIcon, isTile && outline && styles.outline);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [/*#__PURE__*/_jsx("input", {
      onClick: e => {
        // This line is to difference between pressing an arrow key and a real mouse click
        // https://github.com/facebook/react/issues/7407
        if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
          e.currentTarget.blur();
        }
        onClick?.(e);
      },
      ...rest,
      id: inputId,
      type: "radio",
      disabled: disabled,
      ref: inputRef,
      className: styles.input
    }), !!label && isTile ? /*#__PURE__*/_jsxs(LabelWithoutEventBubbling, {
      htmlFor: inputId,
      className: labelClasses,
      children: [/*#__PURE__*/_jsx(LegacyIconRenderer, {
        size: iconSize,
        icon: icon,
        className: styles.icon
      }), label]
    }) : /*#__PURE__*/_jsx(LabelWithoutEventBubbling, {
      htmlFor: inputId,
      className: styles.label,
      children: label
    })]
  });
};